/**
 * @generated SignedSource<<9fff13657ef41483e3a1a7fb7f6e8f16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryPane_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryPaneTitle_item" | "CheckoutMobileSummaryPriceTable_item" | "CheckoutSidebarPromotion_item" | "CheckoutSummaryItemSkuDetails_item" | "useCustomsMessagingQuery_item">;
  readonly " $fragmentType": "CheckoutMobileSummaryPane_item";
};
export type CheckoutMobileSummaryPane_item$key = {
  readonly " $data"?: CheckoutMobileSummaryPane_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryPane_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryPane_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryPaneTitle_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSummaryItemSkuDetails_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryPriceTable_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarPromotion_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCustomsMessagingQuery_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "518af51cb34b944c5253bed27bba1455";

export default node;
